import { focusStyle } from '../styles/mixins';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { themeColorsRgba } from '../theme/tools/theme.utils';
import { StylesIndexInjections } from 'common-react';

  export default makeUiStyles((theme: Theme) => {
    return createStyles({
    root: {
      width: '100%',
    },
    navigationAndPaginationWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingTop: 24,
      paddingBottom: 4,
      gap: 16,
    },
    paginationProgress: {
      height: 1,
      maxWidth: 328,
      width: '100%',
      overflow: 'hidden',
      backgroundColor: theme.color.greys[30]
    },
    paginationProgressFill: {
      height: '100%',
      backgroundColor: theme.color.violets[50]
    },
    carouselNavigationBtn: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      color: theme.color.greys[0],
      width: 32,
      height: 32,
      flexShrink: 0,
      borderRadius: '50%',
      backgroundColor: theme.color.greys[80],
      '&$isDisabled': {
        pointerEvents: 'none',
        backgroundColor: themeColorsRgba(theme).black40,
        color: theme.color.greys[0],
      },
      '&:focus-visible': {
        ...focusStyle(theme, 2)
      }
    },
    carouselNavigationIcon: {
      width: 16,
      height: 16,
    },
    slide: {
      width: ({ slideWidth }: { slideWidth?: string }) => slideWidth,
      height: 'auto',
    },
    carouselPagination: {
      display: 'flex',
      gap: 8,
    },
    carouselPaginationItem: {
      width: 8,
      height: 8,
      margin: 0,
      border: 'none',
      borderRadius: 16,
      padding: 0,
      backgroundColor: theme.color.greys[30],
      transition: 'width 0.3s ease-in-out',
      '&:focus-visible': {
        ...focusStyle(theme, 2)
      }
    },
    isActive: {
      backgroundColor: theme.color.greys[80],
      width: 24,
    },
    isDisabled: {}
  })}, { name: 'Carousel', index: StylesIndexInjections.UI_MOLECULES });
